module.exports = __webpack_public_path__ + "img/fieldwork-2007-picun.6b437872.jpg";